import React, { memo } from 'react'
import { MCNumberForm } from 'src/components/mc-number/MCNumberForm'
import { SecureWrapper } from '../layout/SecureWrapper'

const MCNumberComponent = () => {
  return (
    <SecureWrapper>
      <MCNumberForm />
    </SecureWrapper>
  )
}

export const MCNumber = memo(MCNumberComponent)
